export default {
  sm: `
    네이버 이용자들의 삶이 
    고스란히 담긴 데이터가 
    빠르게 증가하면서 이를 
    디지털 기록으로 소중히 
    보관해야겠다는 사명감이 
    데이터센터 각의 출발입니다.
  `,
  md: `
    네이버 이용자들의 삶이 고스란히 담긴 데이터가 빠르게 
    증가하면서 이를 디지털 기록으로 소중히 
    보관해야겠다는 사명감이 데이터센터 각의 출발입니다.
  `,
};
